var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWorkspaceAddMember = function SvgIconWorkspaceAddMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA4BC",
    fillRule: "evenodd",
    d: "M8.787 3.275c0 1.968-1.107 3.075-3.075 3.075S2.636 5.243 2.636 3.275c0-1.97 1.108-3.076 3.076-3.076s3.075 1.107 3.075 3.076m.337 4.931a2 2 0 0 0-.004.154v.56h-.56a2.24 2.24 0 0 0-1.58 3.83H2.498c-1.054 0-1.928-.566-2.305-1.352a1.86 1.86 0 0 1-.13-1.3c.123-.453.424-.851.876-1.154a8.6 8.6 0 0 1 4.774-1.44c1.212 0 2.366.25 3.412.702m3.076.154a.84.84 0 0 0-1.68 0v1.96H8.56a.84.84 0 0 0 0 1.68h1.96v1.96a.84.84 0 1 0 1.68 0V12h1.96a.84.84 0 0 0 0-1.68H12.2z",
    clipRule: "evenodd"
  })));
};
export default SvgIconWorkspaceAddMember;